/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ due: NonNullable<unknown>, session: NonNullable<unknown> }} Plan_Edit_Rotation_NoteInputs */

const en_us2_plan_edit_rotation_note = /** @type {(inputs: Plan_Edit_Rotation_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Today would be ${i?.due}. Training ${i?.session} now changes the week's order.`)
};

const pt_br2_plan_edit_rotation_note = /** @type {(inputs: Plan_Edit_Rotation_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoje seria o ${i?.due}. Treinar o ${i?.session} agora muda a ordem da semana.`)
};

const es_419_plan_edit_rotation_note = /** @type {(inputs: Plan_Edit_Rotation_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoy tocaría ${i?.due}. Entrenar ${i?.session} ahora cambia el orden de la semana.`)
};

const pt_pt2_plan_edit_rotation_note = /** @type {(inputs: Plan_Edit_Rotation_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoje seria o ${i?.due}. Treinar o ${i?.session} agora muda a ordem da semana.`)
};

const fr_fr2_plan_edit_rotation_note = /** @type {(inputs: Plan_Edit_Rotation_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aujourd'hui, ce serait ${i?.due}. Faire ${i?.session} maintenant change l'ordre de la semaine.`)
};

const de_de2_plan_edit_rotation_note = /** @type {(inputs: Plan_Edit_Rotation_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Heute wäre ${i?.due} dran. Wenn du jetzt ${i?.session} trainierst, ändert sich die Reihenfolge der Woche.`)
};

const it_it2_plan_edit_rotation_note = /** @type {(inputs: Plan_Edit_Rotation_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oggi toccherebbe a ${i?.due}. Fare ${i?.session} adesso cambia l'ordine della settimana.`)
};

/**
* | output |
* | --- |
* | "Today would be {due}. Training {session} now changes the week's order." |
*
* @param {Plan_Edit_Rotation_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_rotation_note = /** @type {((inputs: Plan_Edit_Rotation_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Rotation_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_rotation_note(inputs)
	if (locale === "es-419") return es_419_plan_edit_rotation_note(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_rotation_note(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_rotation_note(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_rotation_note(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_rotation_note(inputs)
	return en_us2_plan_edit_rotation_note(inputs)
});
export { plan_edit_rotation_note as "plan-edit.rotation_note" }